var Plyr = require('plyr');

module.exports = function(link) {
    link.addEventListener('click', function(e) {
        e.preventDefault();
        var plyr = document.querySelector('.plyr');
        if (plyr !== null) {
            return;
        }
        var oldVid = link.querySelector('video');
        var newVid = document.createElement('video');
        var newSrc = document.createElement('source');
        newVid.setAttribute('class','headline');
        newSrc.setAttribute('src', '/images/home_vid_full.mp4');
        newVid.appendChild(newSrc);
        link.removeChild(oldVid);
        link.appendChild(newVid);
        const player = new Plyr(newVid);
        player.play();
        player.on('ended', function() {
            var plyrDiv = document.querySelector('.plyr');
            plyrDiv.classList.add('fadeOut');
            setTimeout(function() {
                var newVid = document.createElement('video');
                var newSrc1 = document.createElement('source');
                newSrc1.setAttribute('src', '/images/blackthorn-home-loop-lq.mp4');
                var newSrc2 = document.createElement('source');
                newSrc2.setAttribute('src', '/images/blackthorn-home-loop-lq.webm');
                newVid.setAttribute('muted', 'muted');
                newVid.setAttribute('loop', 'loop');
                newVid.setAttribute('autoplay', 'autoplay');
                newVid.setAttribute('class','headline fadeIn');
                newVid.appendChild(newSrc1);
                newVid.appendChild(newSrc2);
                player.destroy();
                link.removeChild(link.querySelector('video'));
                link.appendChild(newVid);
            }, 2000);
        })
    });
}